<template>
  <div>
    <div class="container-fluid my-2">
      <SectionTitle :has-line="true" content="Información de Fortalezas" />
      <div class="card-body" :class="{ 'pt-0': ReadOnly }">
        <div class="panel-body">
          <CustomDropDown
            v-if="showNecessitiesCatalogue"
            v-model="selectedGrade"
            :options="gradeOptions"
            label="Grado:"
            fieldkey="id"
            fieldname="name"
            placeholder="Seleccione el Grado"
            class="mb-4 w-25 bold-label"
            :disabled="ReadOnly"
          />
          <MultiSelectionPicker
            v-if="!ReadOnly"
            maxlength="1500"
            :isbgwhite="true"
            :enable-bg-alternate="true"
            :all-items="availableStrengths"
            :selected-items="currentSelection"
            item-type-name="Fortaleza"
            :allow-item-list-editing="
              selectedGrade?.id && hasStrengthEdition && !ReadOnly
            "
            :modify-removes-item="true"
            :column-count="1"
            :disabled="ReadOnly"
            @itemDeleted="deletedStrength"
            @itemAdded="addNewStrength"
            @itemModified="editStrength"
          />

          <div v-if="!ReadOnly" class="row mt-3">
            <div class="col-12">
              <Error
                is-alert-mode
                message="Puede seleccionar una(1) o más fortalezas. Selección múltiple."
              />
            </div>
          </div>
          <div v-if="!ReadOnly" class="row mt-3">
            <div class="col-12">
              <Error
                v-if="hasInnerError"
                message="Favor de seleccionar las fortalezas."
              />
            </div>
          </div>
          <CustomChipsGroup
            title="Fortalezas Seleccionadas"
            :selected-items="wrappedSelection"
            :no-wrap="true"
            object-text="name"
            :disabled="ReadOnly"
            :class="{ 'custom-chips-group': ReadOnly }"
            @itemMarkedForDeletion="removeSelection"
          />
        </div>
      </div>

      <div
        v-if="!ReadOnly"
        class="mt-3 d-flex justify-content-end align-items-center"
      >
        <ActionButton i="fas fa-save" variant="success m-2" @click="save">
          Guardar
        </ActionButton>
      </div>
    </div>
  </div>
</template>

<script>
import ActionButton from "@/components/common/ActionButton";
import MultiSelectionPicker from "@/components/common/MultiSelectionPicker";
import CustomChipsGroup from "@/components/common/CustomChipsGroup";
import alert from "@/mixin/alert.mixin";
import Error from "@/components/common/Error";
import CustomDropDown from "custom-drop-down";
import PeiApi from "./service";

import { modulesName } from "@/modules";
import { createNamespacedHelpers } from "vuex";

import { SectionTitle } from "@/components/pei/shared";

const { mapState, mapGetters, mapActions } = createNamespacedHelpers(
  modulesName.programServiceModuleName
);

export default {
  name: "StrenghtSelection",
  mixins: [alert],
  props: {
    programServiceAreaId: {
      default: 0
    },
    areaId: {
      default: 0
    },
    selectedArea: {
      type: Object,
      default: () => {}
    },
    selectedPeiId: {
      default: 0
    },
    pei: {
      type: Object,
      default: () => {}
    },
    hasError: {
      type: Boolean,
      default: false
    },
    ReadOnly: {
      type: Boolean,
      default: false
    }
  },
  components: {
    ActionButton,
    MultiSelectionPicker,
    CustomDropDown,
    CustomChipsGroup,
    Error,
    SectionTitle
  },
  data() {
    return {
      resources: [],
      availableStrengths: [],
      currentSelection: [],
      deletedStrengths: [],
      idCounter: 0,
      isSubmitted: false,
      selectedGrade: null
    };
  },
  computed: {
    ...mapState(["createdGoals", "selectedStrengths"]),
    ...mapGetters([
      "resource",
      "showNecessitiesCatalogue",
      "gradeOptions",
      "defaultGrade",
      "strengthsOptions",
      "hasStrengthEdition",
      "isDiscipline"
    ]),
    wrappedSelection() {
      return this.currentSelection.map(x => ({ ...x, }));
    },
    selectedItemsWrapper() {
      if (this.showNecessitiesCatalogue) {
        return this.currentSelection.map(item => ({
          ...item,
        }));
      }
      return this.currentSelection;
    },
    hasInnerError() {
      return (
        (this.hasError && !this.currentSelection.length) ||
        (this.isSubmitted && this.currentSelection.length <= 0)
      );
    }
  },
  methods: {
    ...mapActions([
      "fetchStrengthNecessityTabInfo",
      "fetchStrengthTabInfo",
      "fetchGoalsTabInfo"
    ]),
    removeSelection(item) {
      let editedItemIndex = this.currentSelection.findIndex(
        e => e.id === item.id
      );
      this.currentSelection.splice(editedItemIndex, 1);
    },
    editStrength(item, index) {
      if (item.id > 0) {
        item.isDirty = true;
      }
      const newItem = {
        ...item,
        value: this.selectedGrade?.id?.toString(),
        grade: this.selectedGrade?.name
      };
      this.availableStrengths.splice(index, 0, newItem);
    },
    addNewStrength(itemText) {
      this.availableStrengths.push({
        id: (this.idCounter += -1),
        name: itemText,
        value: this.selectedGrade?.id?.toString(),
        grade: this.selectedGrade?.name
      });
    },
    async deletedStrength(item) {
      let alertResponse = await this.ShowCancelModal(
        "Atención",
        `¿Esta seguro que desea eliminar la fortaleza ${item.name}"?`,
        "Aceptar",
        "Cancelar"
      );

      if (!alertResponse) return;

      let removedItemIndex = this.availableStrengths.findIndex(
        e => e.id === item.id
      );
      this.availableStrengths.splice(removedItemIndex, 1);
      if (item.id > 0) this.deletedStrengths.push(item);
    },
    async save() {
      this.isSubmitted = true;
      if (this.currentSelection.length == 0) return false;

      let dto = {
        programServiceAreaId: parseInt(this.programServiceAreaId, 10),
        areaId: parseInt(this.areaId, 10),
        peiId: this.selectedPeiId.toString(),
        selectedStrengths: this.currentSelection,
        availableStrengths: this.availableStrengths,
        deletedStrengths: this.deletedStrengths
      };

      try {
        await PeiApi.SaveStrengthsInfo(dto);
        this.ShowToast(
          this.resource("R03200110"),
          this.resource("R03200109"),
          "success"
        );
        if (this.currentSelection.length <= 0) {
          this.isSubmitted = false;
        }
        this.deletedStrengths = [];
        this.$emit('pending-changes', false);

        await this.fetchGoalsTabInfo(this.selectedGrade?.id);
        await this.fetchStrengthTabInfo(this.selectedGrade?.id);
        await this.fetchStrengthNecessityTabInfo(this.selectedGrade?.id);

        return true;
      } catch (err) {
        this.ShowToast(
          'Error',
          err.response.data.message ?? this.resource("R03200108"),
          "error"
        );
        return false;
      }
    },
  },
  watch: {
    strengthsOptions: {
      deep: true,
      immediate: true,
      handler(newValue) {
        this.availableStrengths = [...newValue];
      }
    },
    selectedStrengths: {
      deep: true,
      immediate: true,
      handler(newValue) {
        const skillNames = this.createdGoals
          .map(x => x.strenghtsAndNecessities.map(y => y.name.trim()))
          .flat();

        this.currentSelection = [...newValue.map(x => ({
            ...x,
            disabled: skillNames.includes(x.name.trim())
        }))];
      }
    },
    selectedGrade: {
      deep: true,
      handler(newValue) {
        this.fetchStrengthTabInfo(newValue?.id);
      }
    },
    defaultGrade: {
      deep: true,
      immediate: true,
      handler(newValue) {
        if (!newValue?.id) return;
        this.selectedGrade = { ...newValue };
      }
    },
    currentSelection: {
      deep: true,
      immediate: false,
      handler(newValue) {
        if (this.selectedStrengths.length != newValue.length) {
          this.$emit('pending-changes', true);
        }
      }
    },
  }
};
</script>
<style lang="scss" scoped>
@import "@/assets/scss/variables/_colors.scss";

.actions {
  display: flex;
  justify-content: flex-end;
}
::v-deep .bold-label > .data-name {
  font-weight: 700;
  color: map-get($colors, "black") !important;
}

::v-deep .custom-chips-group {
  & div.mt-3 {
    margin-top: 0% !important;
  }
  & .chips-container {
    margin-top: 0% !important;
    padding-top: 0% !important;
  }
}
</style>
